import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import OnboardThemeProvider from './components/OnboardThemeProvider';
import SetupPortal from './SetupPortal/SetupPortal';

import type { ComponentProps } from 'react';

// This SPA has no snackbar host (unlike OnboardProviders.tsx / OnboardPortal.tsx), so
// query errors are not routed to a global toast - SetupPortal renders its own
// inline "Portal unavailable" message instead (see useSetupPortalState).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

const OnboardSetupPortal = (props: ComponentProps<typeof SetupPortal>) => (
  <OnboardThemeProvider>
    <QueryClientProvider client={queryClient}>
      <SetupPortal {...props} />
    </QueryClientProvider>
  </OnboardThemeProvider>
);

export default OnboardSetupPortal;
